module.exports = __webpack_public_path__ + "static/media/27-1.6285ca5d.mp3";